import { useEffect, useMemo } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Routes } from '../../../../app/routes';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { useCreateNotificationMutation } from '../../../user/api/user-api';
import { useGetTokenMutation } from '../../api/auth-api';
import { authenticate, selectAuthCredentials, selectCodeVerifier, selectDomain } from '../../store/auth-slice';
import { consumeRedirectAfterLoginPath } from '../../utils/redirect-after-login';
import { getNotificationToken } from '../../../../firebase';

const AuthCallback = (): JSX.Element => {
  const [searchParams] = useSearchParams();
  const [getToken] = useGetTokenMutation();
  const domain = useAppSelector(selectDomain);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const code = useMemo(() => searchParams.get('code'), [searchParams]);
  const codeVerifier = useAppSelector(selectCodeVerifier);
  const authCredentials = useAppSelector(selectAuthCredentials);
  const [createNotification] = useCreateNotificationMutation();

  useEffect(() => {
    if (!code || !codeVerifier || !domain || !authCredentials) {
      navigate(Routes.Login);
      return;
    }

    getToken({
      domain,
      code,
      codeVerifier,
      clientId: authCredentials.client_id,
      clientSecret: authCredentials.client_secret,
    })
      .unwrap()
      .then(() => {
        dispatch(authenticate());
        navigate(consumeRedirectAfterLoginPath() || Routes.Main);
        getNotificationToken().then(token => {
          if (token) {
            createNotification({ token });
          }
        });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [code]);

  return <></>;
};

export default AuthCallback;
